import React from 'react';
import ApplicationMsgWrap from '../../components/ui/forms/ApplicationMsgWrap';

const ApplicationMessages = (props) => {
    const { title, content } = props;
    return(
        <ApplicationMsgWrap data-test-id={props.dataTestId}>
            <div className="ApplicationMsgWrap_title">
                {title}
            </div>
            <div className="ApplicationMsgWrap_content">
                {content}
            </div>
        </ApplicationMsgWrap>
    );
}

export default ApplicationMessages;